import { createAction } from '@reduxjs/toolkit'
import { ResponseClient } from '@ads/front-core/api'
import { AppState } from 'store/appState'

export const setClientLanguage = createAction<
  ResponseClient['settings']['language']
>('user/setClientLanguage')

export const setClientLanguageReducer = (
  state: AppState['client'],
  action: ReturnType<typeof setClientLanguage>,
): void => {
  state.currentClient.settings.language = action.payload
}
